import React, { FunctionComponent } from 'react'

import { JumplinksInline } from '../../../../shared'

export const SuperCategoryJumpLinks: FunctionComponent<Props> = ({ links }) => {
  const prefixedJumplinks = links.map((link) => ({ ...link, prefix: 'super-category' }))

  return <JumplinksInline links={prefixedJumplinks} />
}

///////// IMPLEMENTATION /////////

type Props = { links: { id: number | string; label: string }[] }
